import(/* webpackMode: "eager", webpackExports: ["Header","Trigger"] */ "/vercel/path0/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/before-after-slider/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/feature2/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/pricing/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/testimonial/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/caricature-maker/lazy.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/icon/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/image-cropper/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/qwen-image-edit/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionContent"] */ "/vercel/path0/src/components/ui/accordion.tsx");
